import {
  BACK_KEYS,
  SLICE_SECTIONS,
  STORE_KEYS,
  WATERMARK_STORE_KEYS,
} from '@/components/CompanyConfiguration/constants';
import isEmptyLogoUrl from '@/components/CompanyConfiguration/WatermarkSection/utils';

const { WATERMARK } = SLICE_SECTIONS;

const {
  FOOTER_TEXT,
  SHOW_OTHER_AGENTS_CONTACTS,
  SHOW_NEWS_FROM,
  WEB_PROPERTY_URL,
  DEV_PROPERTY_URL,
  BUSINESS_NAME,
  TIME_ZONE,
  LANGUAGE,
  SMTP,
  PORT,
  LOGO,
  WATERMARK_ENABLED,
  COMPANY_ID,
  API_KEY,
  SHOW_INTERNAL_INFO_IN_API,
  SHOW_NOT_AVAILABLE_IN_API,
  LEGAL_CHECK_REQUIRED,
  PUBLISH_WITHOUT_LEGAL_CHECK,
  LEGAL_CHECK_BASE_TEXT,
} = STORE_KEYS;

const {
  HAS_SETTINGS,
  WATERMARK_LOGO_URL,
  OPACITY,
  SIZE,
  POSITION,
  TYPE,
  MARGIN_PX,
} = WATERMARK_STORE_KEYS;

export function applyCompanySettingsPayload(state, payload) {
  state[FOOTER_TEXT] = payload[BACK_KEYS[FOOTER_TEXT]];
  state[SHOW_OTHER_AGENTS_CONTACTS] =
    payload[BACK_KEYS[SHOW_OTHER_AGENTS_CONTACTS]];
  state[SHOW_NEWS_FROM] = payload[BACK_KEYS[SHOW_NEWS_FROM]];
  state[DEV_PROPERTY_URL] = payload[BACK_KEYS[DEV_PROPERTY_URL]];
  state[WEB_PROPERTY_URL] = payload[BACK_KEYS[WEB_PROPERTY_URL]];
  state[BUSINESS_NAME] = payload[BACK_KEYS[BUSINESS_NAME]];
  state[TIME_ZONE] = payload[BACK_KEYS[TIME_ZONE]];
  state[LANGUAGE] = payload[BACK_KEYS[LANGUAGE]];
  state[SMTP] = payload[BACK_KEYS[SMTP]];
  state[PORT] = payload[BACK_KEYS[PORT]];
  state[LOGO] = payload[BACK_KEYS[LOGO]];
  state[COMPANY_ID] = payload[BACK_KEYS[COMPANY_ID]];

  // Only sent by the backend when the API key / tax waffle flag is active;
  // missing fields keep their current value.
  [
    API_KEY,
    SHOW_INTERNAL_INFO_IN_API,
    SHOW_NOT_AVAILABLE_IN_API,
    LEGAL_CHECK_REQUIRED,
    PUBLISH_WITHOUT_LEGAL_CHECK,
    LEGAL_CHECK_BASE_TEXT,
  ].forEach((key) => {
    state[key] = payload?.[BACK_KEYS[key]] ?? state[key];
  });

  state[WATERMARK][WATERMARK_ENABLED] = payload[BACK_KEYS[WATERMARK_ENABLED]];
}

export function selectHasWatermarkChanges(state) {
  const { watermarkSettings, initialWatermarkSettings } =
    state.CompanySettingsSlice;

  if (!initialWatermarkSettings) {
    return false;
  }

  if (watermarkSettings.newLogoFile) {
    return true;
  }

  const keysToCompare = [
    HAS_SETTINGS,
    WATERMARK_LOGO_URL,
    OPACITY,
    SIZE,
    POSITION,
    TYPE,
    MARGIN_PX,
  ];

  return keysToCompare.some(
    (key) => watermarkSettings[key] !== initialWatermarkSettings[key]
  );
}

export function isCompanyLogoAsWatermark(state) {
  const companyLogo = state.CompanySettingsSlice[LOGO];
  const watermarkLogo =
    state.CompanySettingsSlice[WATERMARK][WATERMARK_LOGO_URL];

  return (
    (companyLogo && watermarkLogo && companyLogo === watermarkLogo) ||
    (companyLogo && !isEmptyLogoUrl(companyLogo) && !watermarkLogo)
  );
}
